import classNames from 'classnames';
import { Fragment, useState } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { MobileDrawer } from '../MDrawer';

interface MoreButtonProps {
  title: string;
  actionItems: { key: string; label: JSX.Element }[];
  className?: string;
}

const MoreButton: React.FC<MoreButtonProps> = ({
  className,
  title,
  actionItems,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <div className={classNames(className, 'trojan-more-button')}>
      <div className="more-wrapper" onClick={handleOpen}>
        <MoreOutlined className="more-icon" />
      </div>
      <MobileDrawer
        rootClassName="more-drawer"
        open={open}
        onClose={handleClose}
        title={title}
      >
        {actionItems.map((item) => (
          <Fragment key={item.key}>{item.label}</Fragment>
        ))}
      </MobileDrawer>
    </div>
  );
};

export default MoreButton;
